import { Injectable } from '@angular/core';
import { Logger } from 'angular2-logger/core';
import { serviceSamlRedirect } from '../../../environments/serviceSamlRedirect';


@Injectable()
export class SsoRedirectService {
    private SsoUrl = '';
    constructor(private _logger: Logger) { }

    public getSamlUrl() {
        let hostname = window.location.hostname;
        this._logger.info('hostname:' + hostname);
        for (var i = 0; i < serviceSamlRedirect.configmaxServiceSamlRedirect.length; i++) {
            if (serviceSamlRedirect.configmaxServiceSamlRedirect[i].name.indexOf(hostname) != -1) {
                this.SsoUrl = serviceSamlRedirect.configmaxServiceSamlRedirect[i].url;
            }
        }
        this._logger.info('serviceUrl:' + this.SsoUrl);
        if (this.SsoUrl == '') {
            this.SsoUrl = "#"
        }
        return this.SsoUrl;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/ssoredirect/sso-redirect.service.ts